<div class="enrollment-steps" id="configure-loyalty-program-step" data-cy="configure-loyalty-program-step">
  <app-loyalty-program-form></app-loyalty-program-form>
</div>
